<template>
  <Marco>
    <div slot="content">
      <div class="main-title">
        <h1 class="title">{{ step.pregunta }}</h1>
      </div>

      <div class="form-container">
        <div class="field">
          <label for="num-doc">Número de documento (obligatorio)</label>
          <div class="NIF">
            <select
              id="type-doc"
              v-model="datosTomador.tipoDoc"
              @click="errorCampos = null"
              required
            >
              <option>NIF</option>
              <option>NIE</option>
              <option>CIF</option>
            </select>
            <input
              id="num-doc"
              type="text"
              v-model="datosTomador.numDoc"
              @keydown="errorCampos = null"
              required
              class="campo"
            />
          </div>
        </div>

        <div class="field">
          <label for="phone">Tu teléfono móvil (obligatorio)</label>
          <input
            id="phone"
            type="tel"
            v-model="datosTomador.telefono"
            @keydown="errorCampos = null"
            @keypress="errorCampos = null"
            class="campo"
          />
        </div>
        <span v-if="datosTomador.tipoDoc == 'CIF'">
          <div class="field">
            <label for="name">Razón social (obligatorio)</label>
            <input
              id="name"
              type="text"
              v-model="datosTomador.nombre"
              class="campo"
            />
          </div>
        </span>
        <span v-if="datosTomador.tipoDoc != 'CIF'">
          <div class="field">
            <label for="name">Tu nombre (obligatorio)</label>
            <input
              id="name"
              type="text"
              v-model="datosTomador.nombre"
              class="campo"
            />
          </div>
          <div class="field">
            <label for="name">Primer apellido (opcional)</label>
            <input
              id="name"
              type="text"
              v-model="datosTomador.ape1"
              class="campo"
            />
          </div>
          <div class="field">
            <label for="name">Segundo apellido (opcional)</label>
            <input
              id="name"
              type="text"
              v-model="datosTomador.ape2"
              class="campo"
            />
          </div>
        </span>

        <div class="field">
          <label for="email">Tu email (opcional)</label>
          <input
            id="email"
            type="email"
            v-model="datosTomador.email"
            @keydown="errorCampos = null"
            class="campo"
          />
        </div>
      </div>

      <div>
        <label class="aceptacion">
          <input
            v-model="acepto"
            id="acepto"
            type="checkbox"
            @click="errorCampos = null"
          />
          He leído y acepto el
          <a href="https://ww2.mmtseguros.es/aviso-legal" target="_blank"
            >Aviso Legal</a
          >
          y la
          <a
            href="https://ww2.mmtseguros.es/politica-de-privacidad"
            target="_blank"
            >Política de Privacidad</a
          >
          .
        </label>
      </div>

      <div class="separador" />

      <div v-if="errorCampos" class="noValido">{{ errorCampos }}</div>
    </div>

    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
    <a slot="botonSiguiente" href="#" @click.prevent="validarCampos()"
      >Siguiente</a
    >
  </Marco>
</template>

<script>
import actions from "@/util/actions.js";

export default {
  store: ["step"],

  data() {
    return {
      datosTomador: {},
      acepto: "",
      errorCampos: ""
    };
  },

  mounted() {
    let vm = this;
    this.$eventBus.$on("errorServidor", function(mensaje) {
      vm.errorCampos = mensaje;
    });

    let datosTomador = actions.getSeleccionAnterior(this.$route.params.np);
    if (datosTomador != null) {
      this.datosTomador = datosTomador;
      this.acepto = true;
    }
  },

  methods: {
    siguiente: async function() {
      actions.setSeleccion(this.$route.params.np, this.datosTomador);
      this.$emit("elegido", this.datosTomador);
    },

    validarCampos() {
      console.log(this.acepto ? true : false);

      this.errorCampos = "";
      if (!this.datosTomador.tipoDoc) {
        this.errorCampos =
          this.errorCampos + "Obligatorio tipo documento de identidad. ";
      }

      if (!this.datosTomador.numDoc) {
        this.errorCampos =
          this.errorCampos + "Obligatorio documento de identidad. ";
      }

      if (!this.datosTomador.telefono) {
        this.errorCampos = this.errorCampos + "Obligatorio teléfono. ";
      }
      if (!this.datosTomador.nombre) {
        this.errorCampos =
          this.errorCampos + "Obligatorio nombre o razón social. ";
      }

      if (!this.acepto) {
        this.errorCampos =
          this.errorCampos + "Obligatorio aceptar política de privacidad. ";
      }

      if (this.errorCampos) {
        return this.errorCampos;
      } else {
        this.siguiente();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-container {
  padding-right: 2rem;
}

label {
  display: block;
  margin-bottom: 0px;
  margin-top: 1.5rem;
}
.NIF {
  display: flex;
  align-items: flex-end;
  select {
    padding: 0.4em;
    border-radius: 0px;
    margin-right: 0.5rem;
  }
}

.aceptacion {
  padding-top: 0.9rem;
  font-size: 1.5rem;
}

.separador {
  height: 2rem;
}

.campo {
  padding: 0.3em;
}
</style>
